var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-up"}},[(_vm.isVisble)?_c('div',{staticClass:"cookie-banner"},[_c('div',{staticClass:"cookie-banner__inner"},[_c('p',{staticClass:"cookie-banner__message",domProps:{"innerHTML":_vm._s(_vm.$t('cookieBanner.message'))}}),_c('button',{staticClass:"cookie-banner__button",on:{"click":_vm.onClose}})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }